// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".stretch-area[data-v-796b7546]{width:-webkit-fill-available}.text-black[data-v-796b7546]{color:#000}.hide-extra[data-v-796b7546]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.custom-button[data-v-796b7546]{cursor:pointer;text-align:center;line-height:10px}.fill-icon[data-v-796b7546]{border:1px solid #fff;background-color:#fff;border-radius:15px}.vl[data-v-796b7546]{border-left:1px solid #a9a9a9}", ""]);
// Exports
module.exports = exports;
